export default __webpack_public_path__ + "static/media/toshkentmijoz.7c7596cb.webp";